import * as Yup from "yup";
import { endpointsMd } from "utils/metadata-split/constant";

export type createExamSchTypeSec1 = {
  scheduled_exam_type_id: string;
  scheduled_exam_name: string;
  subject_ids: string[];
  course_ids: (string | number)[];
  start_date: string;
  minTime: string;
  maxTime: string;
  class_id: string;
};

export const createExamSchSec1InitialValues: createExamSchTypeSec1 = {
  scheduled_exam_type_id: "",
  scheduled_exam_name: "",
  subject_ids: [],
  course_ids: [],
  start_date: "",
  minTime: "",
  maxTime: "",
  class_id: "",
};

export const createExamSchSec1MandatoryFields = [
  { id: "scheduled_exam_type_id" },
  { id: "scheduled_exam_name" },
  { id: "subject_ids" },
  { id: "start_date" },
  { id: "course_ids" },
];

export const createExamSchSec1ValidationSchema = Yup.object().shape({
  scheduled_exam_name: Yup.string().required("Exam Name is required"),
  scheduled_exam_type_id: Yup.string().required("Exam Type is required"),
  start_date: Yup.string().required("Exam Date is required"),
  subject_ids: Yup.array().required().min(1, "Subject is required"),
  course_ids: Yup.array().required().min(1, "Course is required"),
  class_id:Yup.string().required("class is required"),
});

export const createExamScheduleSec1 = () => {
  return [
    {
      id: "scheduled_exam_name",
      type: "text",
      label: `Exam Name`,
      className: "name-styles",
      breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
      required: true,
    },
    {
      id: "scheduled_exam_type_id",
      type: "normal-select",
      label: "Exam Type *",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      options: [],
      list: "exam_type_gq",
      keyValue: { label: "name", value: "id" },
    },
    {
      id: "start_date",
      type: "date-picker",
      label: "Exam Date",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      id: "minTime",
      type: "time-picker",
      label: "Start Time",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
    {
      id: "maxTime",
      type: "time-picker",
      label: "End Time",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
       {
      id: "class_id",
      type: "single-select-dependency",
      label: "Class *",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      required: true,
      list: "class_list_schdule",
      keyValue: { label: "name", value: "id" },
      dependentFields: ["course_ids","subject_ids"],
      dependentFlds: {
        class_course_batch_data: "class_list",
      },
    },
    {
      id: "course_ids",
      type: "multi-select-dependency",
      label: "Course/Program *",
      className: "select-styles",
      required: true,
      isDependent: true,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      list: "course_program_list",
      keyValue: { label: "name", value: "id" },
      dependencyLabel: "Please select Class",
      fieldKeyLists: {},
    },
    {
      id: "subject_ids",
      type: "multi-select-dependency",
      label: "Subject *",
      className: "select-styles",
      required: true,
      isDependent: true,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      list: "subject_course_program_list",
      keyValue: { label: "name", value: "id" },
      dependencyLabel: "Please select Course/Program",
      fieldKeyLists: {},
    },
  ];
};

export type createExamSchTypeSec2 = {
  academic_year_ids: string[];
  state_ids: string[];
  college_ids: string[];
  board_ids: string[];
  batch_ids: string[];
};

export const createExamSchInitialValues: createExamSchTypeSec2 = {
  academic_year_ids: [],
  state_ids: [],
  college_ids: [],
  board_ids: [],
  batch_ids: [],
};

export const createExamSchSec2MandatoryFields = [
  { id: "academic_year_ids" },
  { id: "state_ids" },
  { id: "college_ids" },
  { id: "board_ids" },
  { id: "batch_ids" },
];

export const createExamSchSec2ValidationSchema = Yup.object().shape({
  academic_year_ids: Yup.array().required().min(1, "Academic Year is required"),
  state_ids: Yup.array().required().min(1, "State is required"),
  college_ids: Yup.array().required().min(1, "College is required"),
  board_ids: Yup.array().required().min(1, "Board is required"),
  batch_ids: Yup.array().required().min(1, "Batch is required"),
});

export const createExamScheduleSec2 = () => {
  return [
    {
      id: "academic_year_ids",
      type: "multi-select",
      label: "Academic Year * ",
      className: "select-styles",
      required: true,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      list: "academic_year_list",
      keyValue: { label: "year_name", value: "year_id" },
    },
    {
      id: "state_ids",
      type: "multi-select-dependency",
      label: "State *",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      list: "state_list",
      keyValue: { label: "state_name", value: "state_id" },
      dependentFields: ["college_list"],
      dependentFlds: {
        state_list: "state_list",
        //college_list: "college_id",
      },
    },
    {
      id: "college_ids",
      type: "multi-select-dependency",
      label: "College *",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      isDependent: true,
      options: [],
      list: "college_list",
      dependencyLabel: "Please select State",
      keyValue: { label: "college_name", value: "college_id" },
      fieldKeyLists: {},
    },
    {
      id: "board_ids",
      type: "multi-select-dependency",
      label: "Board *",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      list: "board_list",
      keyValue: { label: "board_name", value: "board_id" },
    },
    {
      id: "batch_ids",
      type: "multi-select-dependency",
      label: "Batch *",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      isDependent: true,
      options: [],
      required: true,
      list: "batch_list",
      dependencyLabel: "Please select Class",
      keyValue: { label: "batch_name", value: "batch_id" },
      fieldKeyLists: {},
      dependentFields: [],
      dependentFlds: {
        batch_list: "batch_list",
      },
    },
  ];
};

export const transformData = (apiData) => {
  const result = {};

  apiData.forEach((item) => {
    const { subject_id, subject_name, chapter_id, topic_id ,course_name ,is_course_hierarchy,is_program_hierarchy } = item;

    if (!result[subject_id]) {
      result[subject_id] = {
        subject_id,
        subject_name,
        chapter_list: [],
        topic_list: [],
        chapter_Topic_list: [],
        course_name ,is_course_hierarchy,is_program_hierarchy
      };
    }

    if (!result[subject_id].chapter_list.includes(+chapter_id)) {
      result[subject_id].chapter_list.push(+chapter_id);
    }

    if (!result[subject_id].topic_list.includes(+topic_id)) {
      result[subject_id].topic_list.push(+topic_id);
    }
  });

  return result;
};
export const transformSubjectData = (apiData) => {
  const result = {};
  apiData.forEach((item) => {
    const { id, name,course_name ,is_course_hierarchy,is_program_hierarchy} = item;
    if (!result[id]) {
      result[id] = {
        subject_id: id,
        subject_name: name,
        chapter_list: [],
        topic_list: [],
        chapter_Topic_list: [],
        course_name,
        is_course_hierarchy,
        is_program_hierarchy,
        course_list: [],
        program_list: [],
      };
      if (is_course_hierarchy) {
        result[id].course_list.push(course_name);
      }
      if (is_program_hierarchy) {
        result[id].program_list.push(course_name);
      }
    } else {
      if (is_course_hierarchy) {
        result[id].course_list.push(course_name);
      }
      if (is_program_hierarchy) {
        result[id].program_list.push(course_name);
      }
    }
  });

  return result;
};

export const mergeSubjectsWithContentHierarchy = (subjects, contentHierarchy) => {
  const result = {};

  // STEP 1: Prepare base structure from subjects
  subjects.forEach((sub) => {
    const { id, name, course_name, is_course_hierarchy, is_program_hierarchy } = sub;
    if (!result[id]) {
      result[id] = {
        subject_id: id,
        subject_name: name,
        chapter_list: [],
        topic_list: [],
        chapter_Topic_list: [], 
        course_name,
        is_course_hierarchy,
        is_program_hierarchy,
        course_list: [],
        program_list: [],
      };
       if (is_course_hierarchy) {
        result[id].course_list.push(course_name);
      }
      if (is_program_hierarchy) {
        result[id].program_list.push(course_name);
      }
    }else{
       if (is_course_hierarchy) {
        result[id].course_list.push(course_name);
      }
      if (is_program_hierarchy) {
        result[id].program_list.push(course_name);
      }
    }
  });

  // STEP 2: Merge content hierarchy ONLY for subjects that exist in subjects list
  contentHierarchy.forEach((item) => {
    const { subject_id, chapter_id, topic_id } = item;

    // Ignore old subjects not present in latest subjects list
    if (!result[subject_id]) return;

    const subjectEntry = result[subject_id];

    // Add chapter_id
    if (!subjectEntry.chapter_list.includes(+chapter_id)) {
      subjectEntry.chapter_list.push(+chapter_id);
    }

    // Add topic_id in format "topic_id--chapter_id"
    const topicValue = `${topic_id}--${chapter_id}`;
    if (!subjectEntry.topic_list.includes(topicValue)) {
      subjectEntry.topic_list.push(topicValue);
    }
  });

  return result;
};


export const isFormIncomplete = (sec1: any, sec2: any) => {
  // Section 1 mandatory fields (minTime, maxTime removed)
  const sec1Fields = [
    "scheduled_exam_name",
    "scheduled_exam_type_id",
    "start_date",
    "subject_ids",
    "course_ids",
    "class_id",
  ];

  // Section 2 mandatory fields
  const sec2Fields = [
    "academic_year_ids",
    "state_ids",
    "college_ids",
    "board_ids",
    "batch_ids",
  ];

  // check sec1 fields
  const sec1Incomplete = sec1Fields.some((field) => {
    const value = sec1?.[field];
    return (
      value === undefined ||
      value === null ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    );
  });

  // check sec2 fields
  const sec2Incomplete = sec2Fields.some((field) => {
    const value = sec2?.[field];
    return (
      value === undefined ||
      value === null ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    );
  });

  return sec1Incomplete || sec2Incomplete; // true = disable
};

export function to24HourTime(timeStr) {
  if (!timeStr) return null;

  // Remove timezone part (like +00, +05:30, -03:00, etc.)
  const cleaned = timeStr.replace(/([+-]\d{2}:?\d{2}|[+-]\d{2})$/, "");

  // Ensure it’s in HH:mm:ss format
  if (/^\d{2}:\d{2}:\d{2}$/.test(cleaned)) {
    return cleaned;
  }

  // If only HH:mm, add seconds
  if (/^\d{2}:\d{2}$/.test(cleaned)) {
    return cleaned + ":00";
  }

  return null; // invalid format
}

export const setTopicSelectedValues = (topicData, value, keyValue) => {
  let valueArray = topicData?.map((object, i) => {
    return object[`${keyValue}`];
  });

  let matchedValues;
  if (Array.isArray(value)) {
    matchedValues = valueArray.filter((val) => value.includes(val));
  } else {
    matchedValues = valueArray.filter((val) => val === value);
  }

  return matchedValues;
};

export const convertToNumbersIfPossible = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return [];

  return arr.map((item) => {
    const num = Number(item);
    return isNaN(num) ? item : num;
  });
};

export const checkIfPeriodic = (id, data:any=[]) => {
  const item = data?.find(obj => obj?.id === id);
  return item?.name?.toLowerCase() === "periodic";
};

export   const filterSubjects = (subjectIds, allSubjects) => {
  return allSubjects
    .filter(sub => subjectIds.includes(sub.id))
    .map(sub => ({
      subjectId: sub.id,
      subjectName: sub.name,
      courseId: sub.courseId,
      courseName: sub.courseName
    }));
};

 export function formatToISTISOString(dateInput) {
 if (!dateInput) return "";

  const date = new Date(dateInput);

  if (isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}T00:00:00.000Z`;
}
